module.exports = __webpack_public_path__ + "static/media/RadioButtonChecked.b2adb3ca.svg";